import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogoutButton } from '@/components/LogoutButton';

export function NotFoundPage() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center gap-4 bg-background">
      <LogoutButton />
      <h1 className="text-4xl font-bold">404</h1>
      <p className="text-muted-foreground">페이지를 찾을 수 없습니다</p>
      <Button asChild>
        <Link to="/">홈으로</Link>
      </Button>
    </div>
  );
}
